import React from "react";
import { Tab, Tabs } from "@mui/material";

const tabRootSx = {
  height: 42,
  minHeight: "42px !important",
  borderBottom: "1px solid var(--sub-border, #dfe6ed)",
  background: "transparent",
  borderRadius: 0,
  p: 0,
  boxSizing: "border-box",
  "& .MuiTabs-scroller, & .MuiTabs-flexContainer, & .MuiTabs-list": {
    height: 42,
    minHeight: 42,
    alignItems: "stretch",
  },
  "& .MuiTab-root": {
    height: 42,
    minHeight: "42px !important",
    px: 1,
    borderRadius: 0,
    textTransform: "none",
    fontSize: 13,
    lineHeight: "20px",
    fontWeight: 700,
    color: "#405064",
    opacity: 1,
    transition: "color .16s ease, background-color .16s ease",
  },
  "& .MuiSvgIcon-root": {
    height: "18px",
    width: "18px"
  },
  "& .MuiTab-root:hover": {
    color: "var(--sub-primary, #0b5cab)",
    background: "rgba(11, 92, 171, .05)",
  },
  "& .Mui-selected": {
    color: "var(--sub-primary, #0b5cab) !important",
    background: "transparent",
  },
  "& .MuiTabs-indicator": {
    display: "block",
    height: 2,
    borderRadius: "999px 999px 0 0",
    backgroundColor: "var(--sub-primary, #0b5cab)",
  },
};

const normalizeTab = (item, index) =>
  typeof item === "object" ? item : { label: item, value: index };

export default function AppTab({
  value,
  onChange,
  tabs = [],
  children,
  variant = "scrollable",
  className,
  sx,
  ...props
}) {
  const normalizedTabs = tabs.map(normalizeTab);

  return (
    <Tabs
      value={value}
      onChange={onChange}
      variant={variant}
      className={className}
      sx={{ ...tabRootSx, ...sx }}
      {...props}
    >
      {children || normalizedTabs.map((item, index) => (
        <Tab
          key={item.key ?? item.value ?? index}
          label={item.label}
          value={item.value ?? index}
          disabled={item.disabled}
          icon={item.icon}
          iconPosition={item.iconPosition ?? "start"}
        />
      ))}
    </Tabs>
  );
}
